export const zoneStopTypes = {
    "WithStops": 10,
    "WithoutStops" : 20,
    "MixedOriginOrDestination" : 30,
    "MixedOriginAndDestination" : 40
}